export default {};throw new Error(`Could not resolve "canvas" imported by "@kandiforge/pptx-renderer".`)